import classNames from 'classnames'
import { IFormCategories } from 'legacy/lut/classes/models/IFormCategories'
import React from 'react'
import sanitize from 'sanitize-html'

import { DescriptionLists } from './main/DescriptionLists'
import { Details } from './main/Details'

import styles from './Main.module.scss'

interface IProps {
  className?: string
  currentCompany: any
  paymentTypes: IFormCategories[]
  areasOfFocus: { name: string }[]
  industriesCovered: { name: string }[]
  software: { name: string }[]
  noData: any
  categories: any
}

export const Main = ({
  className,
  currentCompany,
  paymentTypes,
  software,
  industriesCovered,
  areasOfFocus,
  noData,
  categories,
}: IProps) => {
  return (
    <main className={classNames(styles.root, className || '')}>
      <h1 className={styles.title}>{currentCompany.CompanyLegalName || ''}</h1>

      <Details
        paymentTypes={paymentTypes}
        industriesCovered={industriesCovered}
        noData={noData}
        categories={categories}
      />

      <div
        className={styles.description}
        dangerouslySetInnerHTML={{
          __html: sanitize(currentCompany.Description || ''),
        }}
      />

      <DescriptionLists
        software={software}
        areasOfFocus={areasOfFocus}
        noData={noData}
        categories={categories}
      />
    </main>
  )
}
